<template>
  <div>
    <div v-if="params.data.hasOwnProperty('campaign')">
      <div v-if="!isEditing">
        ${{ parseFloat(this.newbudget).toFixed(2) }}
        <vs-icon
          id="insights-table-adsets-daily-budget-edit-button"
          v-if="!isEditing && this.$canAny('edit_personal_campaigns', 'edit_all_campaigns')"
          class="ml-1 cursor-pointer"
          @click="isEditing = true"
          style="font-size: 15px !important;"
          icon="speakol-edit"
          icon-pack="speakol"
        ></vs-icon>
      </div>
      <div class="flex py-2" v-else>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text dollar-sign dollar-sign-adset">
              <span>$</span>
            </div>
          </template>
          <div class="vx-input-group-default flex-grow">
            <div
              class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
            >
              <div class="vs-con-input">
                <input
                  id="insights-table-adsets-daily-budget-input"
                  min="0"
                  class="vs-inputx vs-input--input vs-input-adset"
                  type="number"
                  @input="setnewbudget($event)"
                  :value="newbudget"
                />
              </div>
              <span></span>
            </div>
          </div>
        </vx-input-group>
        <vs-icon
          id="insights-table-adsets-daily-budget-save-button"
          class="save-new-cpm pt-4 mx-2"
          @click="triggerUpdateAdset()"
          icon="speakol-save"
          icon-pack="speakol"
        ></vs-icon>
        <vs-icon
          id="insights-table-adsets-daily-budget-cancel-button"
          class="cancel-new-cpm pt-4"
          @click="resetBudget()"
          icon="speakol-cancel"
          icon-pack="speakol"
        ></vs-icon>
      </div>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import validateBudget from '@/validators/budget'

export default {
  data () {
    return {
      isEditing: false,
      newbudget: null
    }
  },
  beforeMount () {
    this.newbudget = this.params.data.budget !== 0 ? this.params.data.budget : this.params.data.daily_budget
    this.isEditing = false
  },
  methods: {
    setnewbudget (e) {
      // validate and format the cost_per_action value
      const value = parseFloat(e.target.value)

      if (Number.isNaN(value)) {
        this.newbudget = null
        return
      }

      if (value < 0) {
        return
      }

      if (value > 99999.99) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The value should be less than  99999.99'
        }
        // this.newbudget = 9999.999
        return
      }

      const fraction = value.toString().split('.')[1] || ''

      if (fraction.length > 2) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The Decimals should be up to 2 digits'
        }
        this.newbudget = value.toFixed(2)
        return
      }

      this.newbudget = value
    },
    triggerUpdateAdset () {
      if (this.newbudget === null) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The budget field is required'
        }
        return
      }
      if (this.newbudget <= this.params.data.max_bid_price) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: 'The budget can not be less than or equal the bid value'
        }
        return false
      }

      const budgetValidator = validateBudget(
        this.newbudget,
        this.params.data.campaign.objective.min_daily_budget,
        this.params.data.campaign.start_date,
        this.params.data.campaign.end_date
      )

      if (!budgetValidator.valid) {
        this.params.context.parent.stateModal = {
          type: 'error',
          show: true,
          body: budgetValidator.msg
        }
      } else {
        this.updateAdsetBudget()
      }
    },
    async updateAdsetBudget () {
      try {
        await window.axios.post('/campaigns/update/adset/budget', {
          campaign_id: this.params.data.campaign.id,
          adset_id: this.params.data.id,
          budget: this.newbudget
        })
        this.isEditing = false
        this.params.data.budget !== 0 ? (this.params.data.budget = this.newbudget) : (this.params.data.daily_budget = this.newbudget)
      } catch (error) {
        alert(error)
      }
    },
    resetBudget () {
      this.isEditing = false
      this.newbudget =  this.params.data.budget !== 0 ? this.params.data.budget : this.params.data.daily_budget
    }
  }
}
</script>
<style lang="scss" scoped>
.dollar-sign-adset {
  margin-top: 0;
  height: 40px;
}

.vs-input-adset {
  height: 40px;
}
</style>
